export default __webpack_public_path__ + "static/media/BrandingExpand.ea7d9d0b.svg";